import Title from "./Title";

export default function Features() {
  return (
    <section class="py-16" id="features">
      <div class="container mx-auto px-6 relative">
        <Title
          heading="Tired of Clunky Portfolio Platforms?"
          description="Updating your portfolio should be quick and pain-free. Our platform is designed specifically for jobseekers and new grads like you."
        />

        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          <div class="content-card p-8">
            <div class="feature-icon">⚡</div>
            <h3 class="text-xl font-bold mb-3">Lightning Fast</h3>
            <p>
              Set up your professional portfolio in minutes, not days. Update it
              on the fly when you need it most.
            </p>
          </div>

          <div class="content-card p-8">
            <div class="feature-icon">🌐</div>
            <h3 class="text-xl font-bold mb-3">Free Domain Connection</h3>
            <p>
              Connect your own domain at no extra cost. Make your portfolio
              truly yours with your personal web address.
            </p>
          </div>

          <div class="content-card p-8">
            <div class="feature-icon">🎯</div>
            <h3 class="text-xl font-bold mb-3">No Bloat, Just Results</h3>
            <p>
              Get what you need to succeed, no unnecessary features that slow
              down your site or your flow.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
